<template>
	<div class="sidebar sidebarStyle" :data-color="activeColor">
		<!-- <div class="logo" :style="'background-image:url('+ logoImage+')'" @click="home()"></div> -->

		<div class="sidebar-wrapper">
			<slot name="content"></slot>
			<md-list class="nav">
				<!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
				<slot>
					<sidebar-link v-for="(link,index) in sidebarLinks" :key="link.name + index" :to="link.path" :link="link">
					</sidebar-link>
				</slot>
			</md-list>
		</div>
	</div>
</template>
<script>
	import SidebarLink from './SidebarLink.vue'

	export default {
		components: {
			SidebarLink
		},
		props: {
			title: {
				type: String,
				default: ''
			},
			logoImage: {
				type: String,
				default: require('@/assets/img/logo.png')
			},
			activeColor: {
				type: String,
				default: 'purple',
				validator: (value) => {
					let acceptedValues = ['', 'purple', 'blue', 'green', 'orange', 'red']
					return acceptedValues.indexOf(value) !== -1
				}
			},
			sidebarLinks: {
				type: Array,
				default: () => []
			},
			autoClose: {
				type: Boolean,
				default: true
			}
		},
		methods: {
			home() {
				window.location.href = this.config.redirect_url;
			}
		},
		provide() {
			return {
				autoClose: this.autoClose
			}
		},
	}
</script>
<style>
	@media screen and (min-width: 991px) {
		.nav-mobile-menu {
			display: none;
		}
	}

	.sidebarStyle:after {
		background-color: '#323C45' !important;
	}

	.logo {
		background-size: 85%;
		background-repeat: no-repeat;
		background-position: center center;
		height: 90px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/plugins/SidebarPlugin/SideBar.vue